import capitalize from 'lodash/capitalize'
import { StatsMonth } from '../types'

export const monthsNames = [
  'january',
  'february',
  'march',
  'april',
  'may',
  'june',
  'july',
  'august',
  'september',
  'october',
  'november',
  'december',
]

export const abbreviateMonth = (month: StatsMonth) => {
  return capitalize(month.slice(0, 3))
}

export const getMonthName = (month: number) => {
  return capitalize(monthsNames[month - 1])
}

export const getMonthIndex = (month: StatsMonth, year: number) => {
  return new Date(`${month} 1, ${year}`).getMonth()
}

export const getDayCountInMonth = (month: StatsMonth, year: number) => {
  const monthIndex = getMonthIndex(month, year)
  if (monthIndex === -1) return 30
  const nextMonthDate = new Date(year, monthIndex + 1, 1)
  nextMonthDate.setDate(nextMonthDate.getDate() - 1)
  return nextMonthDate.getDate()
}
